export const BELLTOWER_SCHOOL_ID = 13279
